<template>
	<div class="bg-gray min-height">
		<div class="share-popup margin-auto bg-white">
			<div class="border-bottom pt-10 pb-10">
				<img class="title-logo" src="/images/logo/logo-comento-typo-type.png" />
				<div class="text-caption font-caption">시작하는 사람들의 커리어 커뮤니티</div>
			</div>
			<div class="pt-20">
				<div class="font-login-title f-semi-bold">입사일 입력</div>
				<div class="font">
					코멘토를 통해 딱 맞는 인재를 채용하신 것을 진심으로 축하드립니다. 지원자와 협의한 입사 일정을 코멘토
					관리자에게 알려주세요.
				</div>
			</div>
			<div class="pt-20">
				<span class="font">{{ info.name }}님</span>
				<date-picker
					v-model="workDate"
					class="datepicker font"
					placeholder="입사 일자 선택"
					:format="datePickerFormat"
					:lang="datePickerLang"
					:disabled-date="$_isBeforeToday"
					base
				></date-picker>
			</div>
			<div class="pt-20 text-center">
				<button class="btn font" @click="save">저장하기</button>
			</div>
		</div>
		<alert-modal-component
			:show="show"
			:title="title"
			:message="message"
			type="simple"
			:buttonName="buttonName"
			:successCallback="successCallback"
			@close="show = false"
		></alert-modal-component>
	</div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import datepickerMixin from '../../../../../js/mixins/datepickerMixin';

export default {
	mixins: [datepickerMixin],
	props: ['info'],
	data() {
		return {
			show: false,
			title: '',
			message: '',
			buttonName: '',
			type: '',
			align: 'center',
			successCallback: '',
			datePickerLang: {
				days: ['일', '월', '화', '수', '목', '금', '토'],
				months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			},
			datePickerFormat: 'YYYY-MM-DD',
			workDate: '',
		};
	},
	methods: {
		api() {
			let date = moment(this.workDate).format('YYYY-MM-DD');

			showLoading();
			axios({
				method: 'PATCH',
				url: '/api/work/confirm',
				data: {
					apply_no: this.info.no,
					pass_date: date,
				},
			})
				.then(response => {
					closeLoading();
					console.log(response.data);

					if (response.data.code === 200) {
						this.show = true;
						this.title = '저장 완료';
						this.message = '입사일이 저장되었습니다.<br>코멘토를 이용해주셔서 감사합니다.';
						this.successCallback = '/applicant';
					} else {
						this.show = true;
						this.title = '입사일을 입력하세요!';
						this.message = '입사일이 입력되지 않았습니다.<br>확정된 일정을 입력해주세요.';
					}
				})
				.catch(error => {
					closeLoading();
				});
		},
		save() {
			if (this.workDate === '') {
				this.show = true;
				this.title = '입사일을 입력하세요!';
				this.message = '입사일이 입력되지 않았습니다.<br>확정된 일정을 입력해주세요.';
			} else {
				this.api();
			}
		},
	},
	components: {
		DatePicker,
	},
};
</script>

<style lang="less" scoped>
@border-color: #e1e4e7;

.margin-auto {
	margin: 0 auto;
}

.min-height {
	min-height: 100vh;
}

.title-logo {
	width: 150px;
}

.datepicker.between {
	position: relative;
	top: 15px;
	margin: 0 10px;
}

.mx-datepicker {
	.mx-input-wrapper {
		border: 0 !important;
		border-bottom: 1px solid @border-color !important;
	}

	.mx-input-append {
		display: none;
	}

	input[type='text'] {
		border: 0 !important;
		padding: 10px !important;
		margin-top: 10px !important;
		-webkit-box-shadow: none !important;
		-moz-box-shadow: none !important;
		box-shadow: none !important;
	}

	.mx-input-append {
		top: 5px !important;
	}

	.mx-shortcuts-wrapper {
		display: none !important;
	}

	@media (max-width: 480px) {
		width: 100% !important;
		.mx-range-wrapper {
			width: auto !important;

			.mx-calendar {
				float: initial !important;
			}
		}
	}
}
</style>
